import React, { createContext, useReducer } from 'react'
const initialState = {
  historyState: {},
}
const HistoryContext = createContext(initialState)
const { Provider } = HistoryContext

const HistoryReducer = (state, { type, payload }) => {
  switch (type) {
    case 'SET_HISTORY_STATE':
      return { ...state, historyState: payload }
    default:
      return state
  }
}

const HistoryProvider = ({ children }) => {
  const [state, dispatch] = useReducer(HistoryReducer, initialState)

  const setHistoryState = (payload) =>
    dispatch({ type: 'SET_HISTORY_STATE', payload })

  return (
    <Provider
      value={{
        ...state,
        setHistoryState,
      }}
    >
      {children}
    </Provider>
  )
}

export { HistoryContext, HistoryProvider }
